var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUpload = function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.24 35c9.665 0 17.5-7.835 17.5-17.5S27.904 0 18.24 0C8.575 0 .74 7.835.74 17.5S8.575 35 18.24 35Z",
    fill: "#F6F4FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.076 9H12.81v1.6h11.266V9Zm-5.633 3.2L13.615 17l1.134 1.128 2.89-2.864V25h1.609v-9.736l2.889 2.864L23.27 17l-4.828-4.8Z",
    fill: "#604CC5"
  })));
};

export default SvgUpload;